<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.10716 3.27784V5.35208H7.64734V3.27784C7.64734 2.84825 7.30256 2.5 6.87725 2.5C6.45194 2.5 6.10716 2.84825 6.10716 3.27784Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M6.10716 16.503V9.50055H7.64734V16.503C7.64734 16.6462 7.76227 16.7623 7.90404 16.7623H15.103V18.3179H7.90404C6.91165 18.3179 6.10716 17.5053 6.10716 16.503Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M19.2101 18.3179V16.7623H21.2299C21.6552 16.7623 22 17.1105 22 17.5401C22 17.9697 21.6552 18.3179 21.2299 18.3179H19.2101Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
    <path
      d="M17.9267 8.46343V21.7222C17.9267 22.1518 17.5819 22.5 17.1566 22.5C16.7312 22.5 16.3865 22.1518 16.3865 21.7222V8.46343C16.3865 8.32024 16.2715 8.20415 16.1298 8.20415H2.77009C2.34478 8.20415 2 7.8559 2 7.42631C2 6.99673 2.34478 6.64848 2.77009 6.64848H16.1298C17.1222 6.64848 17.9267 7.46106 17.9267 8.46343Z"
      fill="#0B1922"
      fill-opacity="0.75"
    />
  </svg>
</template>

<script setup lang="ts"></script>
